import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import emailjs from 'emailjs-com';

function FooterOne() {
  const form = useRef();
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      'YOUR_SERVICE_ID',   // replace with your EmailJS Service ID
      'YOUR_TEMPLATE_ID',  // replace with your EmailJS Template ID
      form.current,
      'YOUR_USER_ID'       // replace with your EmailJS User ID
    )
    .then(
      (result) => {
        console.log(result.text);
        setMessage('Thank you! You are subscribed.');
        setStatus('success');
        form.current.reset();
      },
      (error) => {
        console.log(error.text);
        setMessage('Oops! Something went wrong. Please try again.');
        setStatus('error');
      }
    );
  };

  return (
    <footer className="footer-wrapper footer-layout1">
      <div className="widget-area">
        <div className="container">
          {/* Newsletter Area */}
          <div className="newsletter-area">
            <div className="newsletter-top">
              <div className="row gy-4 align-items-center">
                <div className="col-lg-5">
                  <h2 className="newsletter-title text-capitalize mb-0">
                    Get the latest newsletter
                  </h2>
                </div>
                <div className="col-lg-7">
                  <form className="newsletter-form" ref={form} onSubmit={sendEmail}>
                    <input
                      className="form-control"
                      type="email"
                      name="user_email"
                      placeholder="Enter Email"
                      required
                    />
                    <button type="submit" className="th-btn style3">
                      Subscribe Now <img src="/assets/img/icon/plane.svg" alt="plane" />
                    </button>
                  </form>
                  {message && (
                    <p
                      style={{
                        marginTop: '10px',
                        color: status === 'success' ? 'green' : 'red',
                        fontWeight: '500'
                      }}
                    >
                      {message}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Rest of your footer content stays unchanged */}
          <div className="row justify-content-between">
            <div className="col-md-6 col-xl-3">
              <div className="widget footer-widget">
                <div className="th-widget-about">
                  <div className="about-logo">
                    <Link to="/">
                      <img
                        src="/assets/img/logo-white2.png"
                        style={{ width: '100px' }}
                        alt="visto"
                      />
                    </Link>
                  </div>
                  <p className="about-text">
                    Your Trusted Partner for Global Visa Assistance and Travel Planning.
                  </p>
                  <div className="th-social">
                    <Link to="https://www.facebook.com/profile.php?id=61551759005010&ref=pl_edit_xav_ig_profile_page_web#">
                      <i className="fab fa-facebook-f" />
                    </Link>
                    <Link to="https://www.twitter.com/">
                      <i className="fab fa-twitter" />
                    </Link>
                    <Link to="https://www.linkedin.com/">
                      <i className="fab fa-linkedin-in" />
                    </Link>
                    <Link to="https://wa.me/971521816680">
                      <i className="fab fa-whatsapp" />
                    </Link>
                    <Link to="https://instagram.com/vistoplanet">
                      <i className="fab fa-instagram" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-xl-auto">
              <div className="widget widget_nav_menu footer-widget">
                <h3 className="widget_title">Quick Links</h3>
                <div className="menu-all-pages-container">
                  <ul className="menu">
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/">About us</Link></li>
                    <li><Link to="/">Our Service</Link></li>
                    <li><Link to="/contact">Terms of Service</Link></li>
                    <li><Link to="/contact">Tour Booking Now</Link></li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-xl-auto">
              <div className="widget footer-widget">
                <h3 className="widget_title">Address</h3>
                <div className="th-widget-contact">
                  <div className="info-box_text">
                    <div className="icon">
                      <img src="/assets/img/icon/phone.svg" alt="img" />
                    </div>
                    <div className="details">
                      <p>
                        <Link to="tel:+971521816680" className="info-box_link">
                          +971 52 181 6680
                        </Link>
                      </p>
                      <p>
                        <Link to="tel:+971561678861" className="info-box_link">
                          +971 56 167 8861
                        </Link>
                      </p>
                    </div>
                  </div>
                  <div className="info-box_text">
                    <div className="icon">
                      <img src="/assets/img/icon/envelope.svg" alt="img" />
                    </div>
                    <div className="details">
                      <p>
                        <Link to="mailto:info@vistoplanet.com" className="info-box_link">
                          info@vistoplanet.com
                        </Link>
                      </p>
                      <p>
                        <Link to="mailto:b2b@vistoplanet.com" className="info-box_link">
                          b2b@vistoplanet.com
                        </Link>
                      </p>
                    </div>
                  </div>
                  <div className="info-box_text">
                    <div className="icon">
                      <img src="/assets/img/icon/location-dot.svg" alt="img" />
                    </div>
                    <div className="details">
                      <p>Dubai, United Arab Emirates</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-xl-auto">
                            <div className="widget footer-widget">
                                <h3 className="widget_title">Instagram Post</h3>
                                <div className="sidebar-gallery">
                                    <div className="gallery-thumb">
                                        <img
                                            src="/assets/img/widget/gallery_1_1.png"
                                            alt="Gallery"
                                        />
                                       <Link
                                            target="_blank"
                                            to="https://www.instagram.com/p/DP_B4kRiWys/?hl=en"
                                            className="gallery-btn"
                                        >
                                            <i className="fab fa-instagram" />
                                        </Link>
                                    </div>
                                    <div className="gallery-thumb">
                                        <img
                                            src="/assets/img/widget/gallery_1_2.png"
                                            alt="Gallery"
                                        />
                                        <Link
                                            target="_blank"
                                            to="https://www.instagram.com/p/DP1RSB4iUcP/?hl=en"
                                            className="gallery-btn"
                                        >
                                            <i className="fab fa-instagram" />
                                        </Link>
                                    </div>
                                    <div className="gallery-thumb">
                                        <img
                                            src="/assets/img/widget/gallery_1_3.png"
                                            alt="Gallery"
                                        />
                                        <Link
                                            target="_blank"
                                            to="https://www.instagram.com/p/DPyAn5BCa_k/?hl=en"
                                            className="gallery-btn"
                                        >
                                            <i className="fab fa-instagram" />
                                        </Link>
                                    </div>
                                    <div className="gallery-thumb">
                                        <img
                                            src="/assets/img/widget/gallery_1_4.png"
                                            alt="Gallery"
                                        />
                                         <Link
                                            target="_blank"
                                            to="https://www.instagram.com/p/DNhw4S1MMxC/?hl=en"
                                            className="gallery-btn"
                                        >
                                            <i className="fab fa-instagram" />
                                        </Link>
                                    </div>
                                    <div className="gallery-thumb">
                                        <img
                                            src="/assets/img/widget/gallery_1_5.png"
                                            alt="Gallery"
                                        />
                                       <Link
                                            target="_blank"
                                            to="https://www.instagram.com/p/DNpusZ8P_T5/?hl=en"
                                            className="gallery-btn"
                                        >
                                            <i className="fab fa-instagram" />
                                        </Link>
                                    </div>
                                    <div className="gallery-thumb">
                                        <img
                                            src="/assets/img/widget/gallery_1_6.png"
                                            alt="Gallery"
                                        />
                                       <Link
                                            target="_blank"
                                            to="https://www.instagram.com/p/DN0DEy30AXK/?hl=en"
                                            className="gallery-btn"
                                        >
                                            <i className="fab fa-instagram" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="copyright-wrap background-image">
        <div className="container">
          <div className="row justify-content-between align-items-center">
          <div className="col-md-6">
  <p className="copyright-text">
    Copyright {new Date().getFullYear()} <Link to="/">Vistoplanet</Link>. All Rights Reserved.
  </p>
</div>
            <div className="col-md-6 text-end d-none d-md-block">
              <div className="footer-card">
                <span className="title">We Accept</span>
                <img src="/assets/img/shape/cards.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default FooterOne;
